import img1 from '../images/common/delian.jpg';
import img2 from '../images/common/basf.jpg';
import noimageSmall from '../images/common/no_img.png.small.png';
import noimageMiddle from '../images/common/no_img.png.middle.png';

const dataFoot =
{
    img2: img2,
    img1: img1,
    noimageSmall: noimageSmall,
    noimageMiddle: noimageMiddle
}

export default dataFoot;